// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { LabCardType } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface InitState {
  LabRelatedData: Record<string, LabCardType[]>;
  loadingType: LoadingType;
  isLoading: boolean;
  hasMoreRelated: boolean;
  error?: Error;
}

const { getLabRelatedActions } = actionCreatorsList;
export const initialState: InitState = {
  LabRelatedData: {},
  isLoading: true,
  hasMoreRelated: true,
  loadingType: LoadingType.NEW
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getLabRelatedActions.request): {
      const { loadingType } = action.payload;

      return {
        ...state,
        isLoading: true,
        loadingType,
      };
    }
    case getType(getLabRelatedActions.success): {
      const { id, LabRelatedData, loadingType } = action.payload;
      const newData =
        loadingType === LoadingType.NEW
          ? LabRelatedData
          : state.LabRelatedData[id].concat(LabRelatedData);
      const hasMoreRelated = LabRelatedData.length > 0;

      return {
        ...state,
        isLoading: false,
        hasMoreRelated,
        LabRelatedData: {
          [id]: newData
        }
      };
    }
    case getType(getLabRelatedActions.failure): {
      return {
        ...state,
        error: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
